export default {
  name: 'AddressPicker',
  props: {
    data: Object,
    disabled: Boolean
  },
  data () {
    return {
      selectedEntry: {
        text: '',
        streetId: null,
        id: null,
        custom: false
      },
      addressOptions: [],
      prevTextLen: 0,
      currentReq: null
    }
  },
  methods: {
    changeMode (mode) {
      if (mode) {
        this.selectedEntry.id = null;
      }
      this.$emit('selected', this.selectedEntry);
    },
    clearAddress () {
      this.searchTxt = '';
      this.selectedEntry.id = null;
      this.selectedEntry.streetId = null;
      this.selectedEntry.text = null;
      this.$emit('selected', this.selectedEntry);
    },
    searchAddress (text) {
      if (this.selectedEntry.custom) {
        this.$emit('selected', this.selectedEntry);
      } else {
        if (this.prevTextLen > text.length) {
          this.selectedEntry.streetId = null;
          this.selectedEntry.id = null;
        }
        this.prevTextLen = text.length;
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }
        if (text && text.length > 1) {
          let path = 'addresses/find?qry=' + text;
          if (this.selectedEntry.streetId) {
            path += '&streetId=' + this.selectedEntry.streetId;
          }
          const self = this;
          this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, [], function (response) {
            if (response.data) {
              self.addressOptions = response.data;
            }
          });
        } else {
          this.addressOptions = [];
        }
      }
    },
    selectAddress (address) {
      this.selectedEntry.text = address.fullAddress;
      if (parseInt(address.isStreet) === 1) {
        this.selectedEntry.streetId = address.id;
        this.searchAddress(this.selectedEntry.text);
      } else {
        this.selectedEntry.streetId = null;
        this.selectedEntry.id = address.id;
        this.$emit('selected', this.selectedEntry);
      }
    }
  },
  mounted () {
    this.selectedEntry = this.BasicHelper.cloneObject(this.data)
    this.prevTextLen = ((this.selectedEntry.text) ? this.selectedEntry.text.length : -1);
    this.selectedEntry.streetId = null;
    this.selectedEntry.id = ((this.selectedEntry.id) ? this.selectedEntry.id : null);
    this.selectedEntry.custom = ((this.selectedEntry.custom) ? this.selectedEntry.custom : false);
  }
}
